import cart from "./components/cart";
import megamenu from "./components/megamenu";
import stickyHeader from "./components/stickyHeader";
import siteSearch from "./components/site-search";

(() => {
  megamenu.init();
  stickyHeader.init();
  cart.init();
  siteSearch.init();
})();